// Public booking schemas (architecture.md §11 booking engine, §24 M5).
import { z } from 'zod';
import { uuid, email, isoDateTime, isoDate, timezone, promoCodeString } from './common.js';

// Answer to one form question, captured at booking time.
export const bookingAnswerSchema = z.object({
  form_question_id: uuid.optional().nullable(),
  question_label_snapshot: z.string().trim().min(1).max(240),
  answer_value: z.string().trim().max(4000).optional().nullable(),
});

// Public slot lookup for one date (local availability only — never calls Google).
export const publicSlotsQuerySchema = z.object({
  event_type_id: uuid,
  date: isoDate,
  timezone: timezone.optional(),
});

// Public month availability lookup (returns list of available dates in YYYY-MM).
export const publicMonthAvailabilityQuerySchema = z.object({
  event_type_id: uuid,
  month: z.string().regex(/^\d{4}-\d{2}$/, 'Month must be YYYY-MM'),
  timezone: timezone.optional(),
});

// Create a hold (public, bot-checked, idempotent) — §11 write path step 1.
export const createHoldSchema = z.object({
  event_type_id: uuid,
  start_utc: isoDateTime,
  invitee_name: z.string().trim().min(1).max(160),
  invitee_email: email,
  invitee_timezone: timezone.optional(),
  answers: z.array(bookingAnswerSchema).max(100).default([]),
  promo_code: promoCodeString.optional().nullable(),
  // Cloudflare Turnstile token — verified server-side before the hold is created.
  turnstile_token: z.string().min(1).max(4096),
});

// Confirm a free booking (paid flow is post-MVP; §13).
export const confirmBookingSchema = z.object({
  booking_id: uuid,
});

// Host-side booking management.
export const cancelBookingSchema = z.object({
  reason: z.string().trim().max(1000).optional().nullable(),
});
